module.exports = __webpack_public_path__ + "static/media/img_guochan@2x.c007e1c4.png";